import { Block, useStyletron } from "@mezo-org/mezo-clay";
import React, { useEffect } from "react";
import useDropdownStore, { DropdownView } from "../../stores/dropdownStore";
import Root from "./Root/Root";
import Receive from "./Receive/Receive";
import TestnetTopBanner from "./TestnetTopBanner";
function Content(props) {
    const { mezoId, accountAddress, walletAddress, walletType, usdTotalBalance, assets, matsBalance, usdTroveDebt, usdCollateral, otherAssetsCount, otherAssetsUsdTotal, onSignOut, onOtherAssetsClick, } = props;
    const [_, theme] = useStyletron();
    const currentView = useDropdownStore((state) => state.view);
    const setView = useDropdownStore((state) => state.setView);
    useEffect(() => () => {
        setView(DropdownView.ROOT);
    }, [setView]);
    return (React.createElement(Block, { display: "inline-flex", flexDirection: "column", backgroundColor: theme.colors.backgroundPrimary, width: "100%", overrides: {
            Block: {
                style: {
                    boxSizing: "border-box",
                },
            },
        } },
        React.createElement(TestnetTopBanner, null),
        currentView === DropdownView.ROOT && (React.createElement(Root, { mezoId: mezoId, accountAddress: accountAddress, walletAddress: walletAddress, walletType: walletType, usdTotalBalance: usdTotalBalance, assets: assets, matsBalance: matsBalance, usdTroveDebt: usdTroveDebt, usdCollateral: usdCollateral, otherAssetsCount: otherAssetsCount, otherAssetsUsdTotal: otherAssetsUsdTotal, onSignOut: onSignOut, onOtherAssetsClick: onOtherAssetsClick })),
        currentView === DropdownView.RECEIVE && (React.createElement(Receive, { address: accountAddress }))));
}
export default Content;
//# sourceMappingURL=Content.js.map